import React from 'react';
import { useDispatch } from 'react-redux';
import { useUser } from '../../../../hooks/use_user';
import { ProUpsellModalActions } from '../../../../redux/pro_upsell_modal';
import { SignupLoginModalActions } from '../../../../redux/signup_login_modal';
import { PRO_SIGNUP_LOGIN_MODAL_OPEN_PARAMS } from '../../../login_signup_modal/signup_login_modal';
import SvgLockIcon from '../../../svg/lock_icon';
import styles from './modal_non_pro_footer.less';

export const ModalNonProFooter = () => {
  const dispatch = useDispatch();
  const { user, isPro } = useUser();

  return (
    <div
      className={styles.nonProFooter}
      onClick={() => {
        if (!user) {
          dispatch(
            SignupLoginModalActions.SIGNUP_LOGIN_MODAL_OPEN(PRO_SIGNUP_LOGIN_MODAL_OPEN_PARAMS)
          );
        } else if (!isPro) {
          dispatch(ProUpsellModalActions.PRO_UPSELL_MODAL_OPEN());
        }
      }}
    >
      <p>
        <span className={styles.lockIcon}>
          <SvgLockIcon />
        </span>
        <span>Unlock All Layers With PRO</span>
      </p>
    </div>
  );
};
